import { createReducer } from '@reduxjs/toolkit';
import { RequestError, CustomersByStation, CustomersByOD } from 'types';
import { saveBlob } from '../../utils/save-blob';
import {
  fetchCustomersByStation as fetchCustomersByStationAction,
  fetchedCustomersByStation as fetchedCustomersByStationAction,
  fetchCustomersByOD as fetchCustomersByODAction,
  fetchedCustomersByOD as fetchedCustomersByODAction,
  refreshCustomersByStation as refreshCustomersByStationAction,
  refreshedCustomersByStation as refreshedCustomersByStationAction,
  exportCustomersByStation as exportCustomersByStationAction,
  exportedCustomersByStation as exportedCustomersByStationAction,
  refreshCustomersByOD as refreshCustomersByODAction,
  refreshedCustomersByOD as refreshedCustomersByODAction,
  exportCustomersByOD as exportCustomersByODAction,
  exportedCustomersByOD as exportedCustomersByODAction,
  setFilters,
  resetFilters,
} from './actions';
import { CustomersListState } from './types';
import moment from 'moment';

export const INITIAL_STATE: CustomersListState = {
  customersByStation: {
    status: undefined,
    error: undefined,
    data: undefined,
  },
  customersByOD: {
    status: undefined,
    error: undefined,
    data: undefined,
  },
  filters: {
    startDate: moment().format('YYYY-MM-DD'),
    endDate: moment().format('YYYY-MM-DD'),
    pageNumber: 1,
    maxResultPage: 6,
    includedCancel: false,
    includedRolling: false,
  },
};

// https://redux-toolkit.js.org/api/createReducer#the-builder-callback-api
export default createReducer<CustomersListState>(INITIAL_STATE, (builder) =>
  builder
    .addCase(fetchCustomersByStationAction, (state) => {
      state.customersByStation.status = 'loading';
    })
    .addCase(fetchedCustomersByStationAction, (state, action) => {
      const { error, payload } = action;
      if (error === true) {
        state.customersByStation.error = payload as RequestError;
        state.customersByStation.data = undefined;
        state.customersByStation.status = 'error';
      } else {
        state.customersByStation.error = undefined;
        state.customersByStation.status = 'success';
        state.customersByStation.data = payload as CustomersByStation;
      }
    })
    .addCase(fetchCustomersByODAction, (state) => {
      state.customersByOD.status = 'loading';
    })
    .addCase(fetchedCustomersByODAction, (state, action) => {
      const { error, payload } = action;
      if (error === true) {
        state.customersByOD.error = payload as RequestError;
        state.customersByOD.data = undefined;
        state.customersByOD.status = 'error';
      } else {
        state.customersByOD.error = undefined;
        state.customersByOD.status = 'success';
        state.customersByOD.data = payload as CustomersByOD;
      }
    })
    .addCase(refreshCustomersByStationAction, (state) => {
      state.customersByStation.status = 'loading';
    })
    .addCase(refreshedCustomersByStationAction, (state, action) => {
      const { error, payload } = action;
      if (error === true) {
        state.customersByStation.error = payload as RequestError;
        state.customersByStation.data = undefined;
        state.customersByStation.status = 'error';
      } else {
        state.customersByStation.error = undefined;
        state.customersByStation.status = 'success';
        state.customersByStation.data = payload as CustomersByStation;
      }
    })
    .addCase(exportCustomersByStationAction, (state) => {
      state.customersByStation.status = 'loading';
    })
    .addCase(exportedCustomersByStationAction, (state, action) => {
      const { error, payload } = action;
      if (error === true) {
        state.customersByStation.error = payload as RequestError;
        state.customersByStation.data = undefined;
        state.customersByStation.status = 'error';
      } else {
        const returnState = saveBlob(payload, 'customersByStation');
        state.customersByStation.error = returnState.error;
        state.customersByStation.status = returnState.status;
      }
    })
    .addCase(refreshCustomersByODAction, (state) => {
      state.customersByOD.status = 'loading';
    })
    .addCase(refreshedCustomersByODAction, (state, action) => {
      const { error, payload } = action;
      if (error === true) {
        state.customersByOD.error = payload as RequestError;
        state.customersByOD.data = undefined;
        state.customersByOD.status = 'error';
      } else {
        state.customersByOD.error = undefined;
        state.customersByOD.status = 'success';
        state.customersByOD.data = payload as CustomersByOD;
      }
    })
    .addCase(exportCustomersByODAction, (state) => {
      state.customersByOD.status = 'loading';
    })
    .addCase(exportedCustomersByODAction, (state, action) => {
      const { error, payload } = action;
      if (error === true) {
        state.customersByOD.error = payload as RequestError;
        state.customersByOD.data = undefined;
        state.customersByOD.status = 'error';
      } else {
        const returnState = saveBlob(payload, 'customersByOD');
        state.customersByOD.error = returnState.error;
        state.customersByOD.status = returnState.status;
      }
    })
    .addCase(setFilters, (state, action) => {
      const { payload } = action;
      state.filters = payload;
    })
    .addCase(resetFilters, (state) => {
      state.filters = INITIAL_STATE.filters;
    })
);
